import { useState } from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormLanguageInputController, FormSwitchController } from '@/components';
import { LanguageTypes } from '@/features';
import { FilterTypes } from '@/features/foodCategory/types/FilterTypes';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const FiltersDialog = () => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext<FilterTypes>();
  const [selectedNameLang, setSelectedNameLang] = useState<LanguageTypes>('cs');

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ ...styles.container, background: palette.surface.white }}
    >
      <FormLanguageInputController
        label={t('HEADERS.NAME')}
        controllerName="name"
        selectedLanguage={selectedNameLang}
        setSelectedLanguage={setSelectedNameLang}
        error={!!errors.name}
        errorText={
          errors.name?.cs?.message ||
          errors.name?.en?.message ||
          errors.name?.de?.message ||
          t('GLOBAL.MIN_ONE_LANG')
        }
      />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ width: '100%', marginTop: '8px' }}
      >
        <FormSwitchController controllerName="showImmediately" label={t('SWITCHER.ACTIVE')} />
      </Stack>
    </Stack>
  );
};
